import { useState } from 'react';
import './MemberForm.scss';
import Form from './components/Form';
import { ReactComponent as Close } from './st-close.svg';
import ClosePopup from './components/ClosePopup';

function MemberForm() {
  const [showPopup, changeShowPopup] = useState(false);

  return (
    <div className="member-form">
      <div className="close-form" onClick={() => changeShowPopup(true)}>
        <Close />
      </div>
      {showPopup && <ClosePopup changeShowPopup={changeShowPopup} />}
      <Form />
    </div>
  );
}

export default MemberForm;
